<div>
  <ng-content></ng-content>
  <kl-grid-container
    (onCustomFilter)="onCustomFilter($event)"
    (onEditCell)="editRecord($event)"
    (onDblClickEditCell)="dblClickCall($event)"
    (onViewCell)="viewRecord($event)"
    (onDeleteCell)="deleteRecord($event)"
    (onInfoCell)="infoRecord($event)"
    (onNew)="addRecord($event)"
    (onFilter)="onFilter($event)"
    (onRefresh)="filter(_filter)"
    (onSortable)="openSortable()"
    (onExport)="onExport($event)"
    (onCloseAlert)="closeAlert()"
    [alertMessage]="alertMessage"
    [alertType]="alertType"
    [alertShow]="alertShow"
    [actions]="actions"
    [tabId]="tabId"
    [processesActions]="processesActions"
    [collectionView]="collectionView"
    [showButton]="service.showButton"
    [disabledButton]="disabledButton"
    [deferResizing]="deferResizing"
    [parentModuleName]="parentModuleName"
    [moduleName]="moduleName"
    [gridName]="gridName"
    [authGroupShow]="authGroupShow"
    [authGroupList]="authGroupList"
    [fastFilterObject]="fastFilterObject"
    [fastFilterName]="fastFilterName"
    [filterObject]="filterObject"
    [filterSelectItems]="filterSelectItems"
    [textToFilter]="templateContext?.textToFilter"
    [specialType]="service.specialType"
    [initStatesWithoutChild]="initStatesWithoutChild"
    [initStatesWithChild]="initStatesWithChild"
    [filterable]="filterable"
    [gridHeaderName]="service.name"
    [sortable]="sortable"
    [showToolbar]="showToolbar"
    [customToolbar]="customToolbar"
    [customFilter]="customFilter"
    [columns]="columns"
    [doAdd]="doAdd"
  >
  </kl-grid-container>
  <kl-grid-pagination
    [hidden]="!collectionView?.sourceCollection?.length"
    [pageOffset]="pageOffset"
    [totalCount]="totalCount"
    [pageSize]="pageSize"
    (onPageChange)="movePage($event)"
  >
  </kl-grid-pagination>
</div>
